import { UnsavedChangesModal } from '@/components/specific-modals/unsaved-changes-modal-models';
import { action, createModule, mutation } from 'vuex-class-component';
import { AddEditDocumentDialogResult } from './../../documents/add-edit-document-dialog/add-edit-document-dialog-models';
import {
  DangerModal,
  DangerModalParams,
  DangerModalResult,
  FormModal,
  FormModalParams,
  FormModalResult,
} from './form-modal-models';
// hmm, this probably should be in components, not areas. Oh well.
import {
  AddEditDocumentDialog,
  AddEditDocumentDialogParams,
} from '@/components/documents/add-edit-document-dialog/add-edit-document-dialog-models';
import {
  CreateDocumentAssociationsDialog,
  CreateDocumentAssociationsDialogParams,
  CreateDocumentAssociationsDialogResult,
} from '@/components/documents/create-document-associations/create-document-associations-models';
import {
  SelectDocumentDialog,
  SelectDocumentDialogParams,
  SelectDocumentDialogResult,
} from '@/components/documents/select-document-dialog/select-document-dialog-models';
import {
  AconexImportDialog,
  AconexImportDialogParams,
  AconexImportDialogResult,
} from '@/components/documents/aconex-import-dialog/aconex-import-dialog-models';

const vuexModule = createModule({
  namespaced: 'modal',
  strict: false,
});

export default class ModalModule extends vuexModule {
  public formModalRef: FormModal | null = null;
  public dangerModalRef: DangerModal | null = null;
  public unsavedChangesModalRef: UnsavedChangesModal | null = null;
  public addEditDocumentDialogRef: AddEditDocumentDialog | null = null;
  public createDocumentAssociationsDialogRef: CreateDocumentAssociationsDialog | null = null;
  public selectDocumentDialogRef: SelectDocumentDialog | null = null;
  public aconexImportDialogRef: AconexImportDialog | null = null;

  // * GETTERS

  // * MUTATIONS
  @mutation
  public setFormModalRef(modalRef: FormModal): void {
    this.formModalRef = modalRef;
  }

  @mutation
  public setDangerModal(modalRef: DangerModal): void {
    this.dangerModalRef = modalRef;
  }

  @mutation
  public setUnsavedChangesModalRef(modalRef: UnsavedChangesModal): void {
    this.unsavedChangesModalRef = modalRef;
  }

  @mutation
  public setAddEditDocumentDialogRef(modalRef: AddEditDocumentDialog): void {
    this.addEditDocumentDialogRef = modalRef;
  }

  @mutation
  public setCreateDocumentAssociationsDialogRef(modalRef: CreateDocumentAssociationsDialog): void {
    this.createDocumentAssociationsDialogRef = modalRef;
  }

  @mutation
  public setSelectDocumentDialogRef(modalRef: SelectDocumentDialog): void {
    this.selectDocumentDialogRef = modalRef;
  }

  @mutation
  public setAconexImportDialogRef(modalRef: AconexImportDialog): void {
    this.aconexImportDialogRef = modalRef;
  }

  // * ACTIONS
  @action
  public async openFormModal(params: FormModalParams) {
    if (this.formModalRef) {
      const result = await this.formModalRef.open(params);
      return result;
    }
    return new FormModalResult({ ok: false });
  }

  @action
  public async openDangerModal(params: DangerModalParams) {
    if (this.dangerModalRef) {
      const result = await this.dangerModalRef.open(params);
      return result;
    }
    return new DangerModalResult({ ok: false });
  }

  @action
  public async openUnsavedChangesModal() {
    if (this.unsavedChangesModalRef) {
      const result = await this.unsavedChangesModalRef.open();
      return result;
    }
    return new FormModalResult({ ok: false });
  }

  @action
  public async openAddEditDocumentDialog(params: AddEditDocumentDialogParams) {
    if (this.addEditDocumentDialogRef) {
      const result = await this.addEditDocumentDialogRef.open(params);
      return result;
    }
    return new AddEditDocumentDialogResult({ ok: false });
  }

  @action
  public async openCreateDocumentAssociationsDialog(params: CreateDocumentAssociationsDialogParams) {
    if (this.createDocumentAssociationsDialogRef) {
      const result = await this.createDocumentAssociationsDialogRef.open(params);
      return result;
    }
    return new CreateDocumentAssociationsDialogResult({ ok: false });
  }

  @action
  public async openSelectDocumentDialog(params: SelectDocumentDialogParams) {
    if (this.selectDocumentDialogRef) {
      const result = await this.selectDocumentDialogRef.open(params);
      return result;
    }
    return new SelectDocumentDialogResult({ ok: false });
  }

  @action
  public async openAconexImportDialog(params: AconexImportDialogParams) {
    if (this.aconexImportDialogRef) {
      const result = await this.aconexImportDialogRef.open(params);
      return result;
    }
    return new AconexImportDialogResult({ didImport: false });
  }
}
